import React from "react";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { BottomNavBar } from "../common";
import "./animation.css";
import { isMobile } from "react-device-detect";

const useStyles = makeStyles((theme) => ({
  canvas: {
    minHeight: "100vh",
    width: "100vw",
    marginTop: 0,
    display: "flex",
    justifyContent: "center",
  },
  paper: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    marginTop: 50,
    marginBottom: 89,
    [theme.breakpoints.down("sm")]: {
      marginBottom: 50,
    },
  },
  content: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
    flex: 8,
    [theme.breakpoints.down("sm")]: {
      marginBottom: 10,
    },
  },
  questionContainer: {
    display: "flex",
    flex: 2,
    justifyContent: "center",
  },
  questionContainerHalf: {
    display: "flex",
    flex: 2,
    justifyContent: "center",
    maxWidth: 800,
  },
  questionContainerHalfShift: {
    display: "flex",
    flex: 2,
    justifyContent: "center",
    maxWidth: 700,
    marginRight: 120,
    [theme.breakpoints.down("md")]: {
      maxWidth: 600,
      marginRight: 300,
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: 700,
      marginRight: 0,
    },
  },
  questionContainerEqual: {
    display: "flex",
    flex: 3,
    justifyContent: "center",
  },
  question: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    [theme.breakpoints.down("xs")]: {
      minHeight: "80vh",
    },
    width: "90%",
    background: "#C4C4C4",
    padding: 20,
  },
  answerContainer: {
    display: "flex",
    flex: 3,
    alignItems: "flex-end",
    [theme.breakpoints.down("xs")]: {
      alignItems: "center",
      justifyContent: "center",
      marginTop: 20,
      marginBottom: 20,
    },
  },
  titleContainer: {
    display: "flex",
    flex: 1,
    justifyContent: "center",
  },
  answer: {
    height: "100%",
    [theme.breakpoints.down("xs")]: {
      minHeight: "80vh",
    },
    width: "90%",
    background: "#C4C4C4",
    padding: 20,
    margin: "auto",
  },
  answerHalf: {
    height: "100%",
    [theme.breakpoints.down("xs")]: {
      minHeight: "50vh",
    },
    width: "90%",
    background: "#C4C4C4",
    padding: 20,
    margin: "auto",
  },
  answerFull: {
    height: "100%",
    [theme.breakpoints.down("xs")]: {
      minHeight: "80vh",
    },
    width: "95%",
    background: "#C4C4C4",
    padding: 20,
    margin: "auto",
  },
}));

const GameModalLayout = ({
  title,
  left,
  right,
  answerHalf,
  full,
  equal,
  answerHalfCenter,
  answerHalfCenterShift,
}) => {
  const classes = useStyles();

  if (full) {
    return (
      <div className={classes.canvas}>
        <div className={classes.paper}>
          <div className={`${classes.content} fadein`}>
            <div className={classes.answerContainer}>
              <Paper className={classes.answerFull}>{left}</Paper>
            </div>
          </div>
          <BottomNavBar />
        </div>
      </div>
    );
  }

  if (equal) {
    return (
      <div className={classes.canvas}>
        <div className={classes.paper}>
          <div className={`${classes.content} fadein`}>
            <div className={classes.questionContainerEqual}>
              <Paper className={classes.question}>{left}</Paper>
            </div>
            <div className={classes.answerContainer}>
              {right ? (
                answerHalf ? (
                  <Paper className={classes.answerHalf}>{right}</Paper>
                ) : (
                  <Paper className={classes.answer}>{right}</Paper>
                )
              ) : (
                <></>
              )}
            </div>
          </div>
          <BottomNavBar />
        </div>
      </div>
    );
  }

  if (answerHalfCenter) {
    return (
      <div className={classes.canvas}>
        <div className={classes.paper} style={{ marginBottom: 62 }}>
          <div className={`${classes.content} fadein`}>
            <div className={classes.questionContainerHalf}>
              <Paper className={classes.question}>
                {title ? (
                  <div className={classes.titleContainer}>
                    <Typography variant="h2">{title}</Typography>
                  </div>
                ) : null}
                {left}
              </Paper>
            </div>
          </div>
          <BottomNavBar />
        </div>
      </div>
    );
  }

  if (answerHalfCenterShift) {
    return (
      <div className={classes.canvas}>
        <div className={classes.paper} style={{ marginBottom: 62 }}>
          <div className={`${classes.content} fadein`}>
            <div
              className={
                isMobile
                  ? classes.questionContainerHalfShift
                  : classes.questionContainerHalf
              }
            >
              <Paper className={classes.question}>
                {title ? (
                  <div className={classes.titleContainer}>
                    <Typography variant="h2">{title}</Typography>
                  </div>
                ) : null}
                {left}
              </Paper>
            </div>
          </div>
          <BottomNavBar />
        </div>
      </div>
    );
  }

  return (
    <div className={classes.canvas}>
      <div className={classes.paper}>
        <div className={`${classes.content} fadein`}>
          <div className={classes.questionContainer}>
            <Paper className={classes.question}>
              {title ? (
                <div className={classes.titleContainer}>
                  <Typography variant="h2">{title}</Typography>
                </div>
              ) : null}
              {left}
            </Paper>
          </div>
          <div id="usedInDesktopInfo" className={classes.answerContainer}>
            {right ? (
              answerHalf ? (
                <Paper className={classes.answerHalf}>{right}</Paper>
              ) : (
                <Paper className={classes.answer}>{right}</Paper>
              )
            ) : (
              <></>
            )}
          </div>
        </div>
        <BottomNavBar />
      </div>
    </div>
  );
};

export default GameModalLayout;
